module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_0-140b1e20fc0988e9ebee6e6e76ae40e9.png";